import './AnnouncementAlert.scss'
import { useEffect, useState } from "react";
import { useAuth } from '../../../../contexts/auth';
import { Button } from 'devextreme-react/button';
import { useNavigate } from 'react-router-dom';
import { useGetAnnouncements } from '../../../../api/announcements';

export default function AnnouncementAlert(props: { onVisibilityChanged: (visible: boolean) => void }) {
	const { user } = useAuth();

	const announcements = useGetAnnouncements(false, user?.userName!);
	const [isVisible, setVisible] = useState(true);

	useEffect(() => {
		props.onVisibilityChanged(isVisible && announcements.data.length > 0);
	}, [announcements.data, isVisible]);

	const navigate = useNavigate();

	return (
		<>
			{
				isVisible && announcements.data.length > 0 &&
				<div className={'announcement-alert'}>
					<div className='announcement-alert-text'>
						<i className='dx-icon dx-icon-Inscyth-Message'></i>
						<span>
							{announcements.data.length === 1 ?
								"You have one unread announcement message" :
								`You have ${announcements.data.length} unread announcement messages`}
						</span>
						<Button
							text="View"
							elementAttr={{ 'data-testid': 'btn-open-announcements' }}
							onClick={() => {
								setVisible(false);
								navigate('/announcement');
							}}>
						</Button>
					</div>
					<a
						className='announcement-alert-close'
						href=""
						onClick={(e) => { e.preventDefault(); setVisible(false); }}
						title="Close"
					>
						<i className='dx-icon dx-icon-close'></i>
					</a>
				</div>
			}
		</>
	)
}
